var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnreadmsgright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5909 18.6348C7.98142 18.2443 7.98142 17.6112 7.5909 17.2206L3.298 12.9277L7.5909 8.63484C7.98142 8.24432 7.98142 7.61115 7.5909 7.22063C7.20037 6.8301 6.56721 6.8301 6.17668 7.22063L1.17668 12.2206C0.786158 12.6112 0.786158 13.2443 1.17668 13.6348L6.17668 18.6348C6.56721 19.0254 7.20037 19.0254 7.5909 18.6348Z",
    fill: "#C4C7C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.883789 12.9277C0.883789 13.48 1.3315 13.9277 1.88379 13.9277L9.88379 13.9277C15.9591 13.9277 20.8838 9.00302 20.8838 2.92773V1.92773C20.8838 1.37545 20.4361 0.927734 19.8838 0.927734C19.3315 0.927734 18.8838 1.37545 18.8838 1.92773V2.92773C18.8838 7.89845 14.8545 11.9277 9.88379 11.9277H1.88379C1.3315 11.9277 0.883789 12.3754 0.883789 12.9277Z",
    fill: "#C4C7C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnreadmsgright);
export default __webpack_public_path__ + "static/media/unreadmsgright.d962db7bb35688397211eda5075887bb.svg";
export { ForwardRef as ReactComponent };